import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Inject, Input, Output } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClientCoreModule, ClientEnvironment, ENVIRONMENT, FormArrayMapping, TableColumn } from '@thehubz/client/core';
import { CustomClients } from '@thehubz/shared/branding';
import { AnyType, BuyoutRightsMakeOSSecondLevel } from '@thehubz/shared/model';
import { BuyoutRightsConfig } from '../../asset-upload/stepper-config/asset-settings-stepper.constants';
import { BuyoutUtilsService } from '../buyout-utils.service';
import { KeyValueUtilPipe } from '../keyvalue-util.pipe';

@Component({
  selector: 'thehubz-buyout-rights-standard',
  standalone: true,
  imports: [MatIconModule, MatTooltipModule, CommonModule, MatExpansionModule, KeyValueUtilPipe, ClientCoreModule, MatCheckboxModule],
  templateUrl: './buyout-rights-standard.component.html',
  styleUrl: './buyout-rights-standard.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuyoutRightsStandardComponent {
  @Input({ required: true }) formValue: AnyType;
  @Input({ required: true }) buyoutRightsConfigs!: BuyoutRightsConfig;
  @Input({ required: true }) columns: TableColumn[] = [];
  @Input() dateMultiEditText!: FormArrayMapping;
  @Input() disableHostStyling = false;
  @Input() expanded = true;
  @Input() callFrom!: string;

  @Output() editBuyoutRights = new EventEmitter();
  @Output() deleteBuyoutRights = new EventEmitter();

  BuyoutRightsMakeOSSecondLevel = BuyoutRightsMakeOSSecondLevel;

  brandingKey!: CustomClients;

  @HostBinding('class.no-host-style')
  get removeStyleClass() {
    return this.disableHostStyling;
  }

  constructor(
    @Inject(ENVIRONMENT) env: ClientEnvironment,
    protected buyoutUtilsService: BuyoutUtilsService,
  ) {
    this.brandingKey = env.brandingKey ?? CustomClients.Standard;
  }
}
